import React, { useState, useRef } from "react";
import EditIcon from "../../ui/EditIcon";
import ActionIconButton from "../../ui/ActionIconButton";
import { Table } from "antd";

import { capitalizeFirstLetter } from "../../../helpers/utility";
import OnboardingForm from "./OnboardingForm";
import useIsMobile from "../../../hooks/useIsMobile";
import usePageFillTableScroll from "../../../hooks/usePageFillTableScroll";

const OnboardingTable = ({ data, refresh, loading }) => {
  const [editData, setEditData] = useState({});
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const tableWrapRef = useRef(null);
  const tableScroll = usePageFillTableScroll(
    tableWrapRef,
    isMobile,
    "default",
    Array.isArray(data) ? data.length : 0
  );

  const columns = [
    { title: "Mobile", dataIndex: "mobile", key: "mobile" },
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (value, record) =>
        capitalizeFirstLetter(value) +
        " " +
        capitalizeFirstLetter(record?.last_name),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (value) => (value ? value : "-"),
    },
    { title: "Address", dataIndex: "address", key: "address" },
    {
      title: "Hospital",
      dataIndex: "partner_organization",
      key: "partner_organization",
    },
    {
      title: "Specilization",
      dataIndex: "experience",
      key: "experience",
      render: (value) => (value ? value?.specilization : "-"),
    },
    { title: "Notes", dataIndex: "notes", key: "notes" },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <ActionIconButton
          aria-label="Edit partner"
          onClick={() => {
            setOpen(true);
            setEditData(record);
          }}
        >
          <EditIcon />
        </ActionIconButton>
      ),
    },
  ];
  return (
    <div ref={tableWrapRef} className="ui-table-fill-body">
      <Table
        className="no-vertical-borders"
        dataSource={data}
        columns={columns}
        pagination={false}
        loading={loading}
        scroll={tableScroll}
      />
      {open && (
        <OnboardingForm
          open={open}
          setOpen={setOpen}
          editData={editData}
          refresh={refresh}
        />
      )}
    </div>
  );
};

export default OnboardingTable;
